// extracted by mini-css-extract-plugin
export default {"locked":"_29tkg","fixed":"ZBSlG","stretch":"b3LBc"};